import i18n from '@signavio/i18n'
import { useParams } from 'react-router'

import { ProvideFileScopeContext, types } from '@signavio/effektif-api'
import { Hint, Markdown } from '@signavio/effektif-commons'
import { StartForm } from '@signavio/workflow-cases'
import { useApi } from '@signavio/effektif-api'

function CreateCaseStartForm() {
  const { processId } = useParams()
  const [createCaseRequest, createCase] = useApi(types.CASE_PUBLIC, {
    method: 'create',
    query: {
      sourceWorkflowId: processId,
    },
  })

  if (createCaseRequest.pending) {
    return (
      <Hint loading view>
        {i18n('Starting your process...')}
      </Hint>
    )
  }

  if (createCaseRequest.fulfilled) {
    return (
      <Markdown>
        {createCaseRequest.value.caseCreatedMessage ||
          i18n('You successfully created the case.')}
      </Markdown>
    )
  }

  return (
    <>
      {createCaseRequest.rejected && (
        <Hint danger>{createCaseRequest.reason}</Hint>
      )}
      <ProvideFileScopeContext publicFileScope workflowId={processId}>
        <StartForm
          publicFileScope
          processId={processId}
          onSubmit={(fields) =>
            createCase({
              sourceWorkflowId: processId,
              fields,
            })
          }
        />
      </ProvideFileScopeContext>
    </>
  )
}

export default CreateCaseStartForm
